<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-11-16 15:51:23
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-06 11:02:40
-->
<template>
  <div class="content">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column
        prop="number"
        label="序号"
        width="120"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="person"
        label="转让人"
        min-width="6%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="time"
        label="流转期限"
        min-width="6%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="area"
        label="流转面积（亩）"
        min-width="6%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="price"
        label="流转单价（元/亩/年）"
        min-width="6%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="total"
        label="流转总价（元）"
        min-width="6%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
    </el-table>
    <!-- <el-pagination
      background
      layout="total,prev, pager, next,jumper"
      :total="1000"
    >
    </el-pagination> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        // {
        //   number: "1",
        //   person: "张三",
        //   time: "2022年 至 2023年",
        //   area: "1000",
        //   price: "800",
        //   total: "760000",
        // },
        // {
        //   number: "1",
        //   person: "张三",
        //   time: "2022年 至 2023年",
        //   area: "1000",
        //   price: "800",
        //   total: "760000",
        // },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.el-table {
  border: 1px solid #dfe7eb;
  border-bottom: none;
}
</style>
